export default __webpack_public_path__ + "static/media/spell-check.f5223ae6.svg";